import { createReducer } from '../../utils/misc'

import {
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_UPDATE_USER_SUCCESS,
  FETCH_USER_PERSONAL_DATA_ERROR,
  FETCH_UPDATE_USER_ERROR,
  FETCH_USER_PERSONAL_DATA_REQUEST,
  FETCH_USER_PERSONAL_DATA_SUCCESS,
  FETCH_USER_VIGENTE_REQUEST,
  FETCH_USER_VIGENTE_SUCCESS,
  FETCH_USER_VIGENTE_ERROR,
  USER_HAS_CVL,
  USER_HAS_SOLICITUD_CREDITO
} from '../constants/user'
import {
  UNAUTH_USER
} from '../constants/auth'

const initialState = {
  fetchingUser: false,
  fetchingPersonalData: false,
  id: null,
  username: '',
  rut: '',
  type: '',
  name: '',
  lastName: '',
  serialNumber: '',
  email: '',
  statusCCR: '',
  address: {
    street: '',
    number: '',
    apartOrHouse: '',
    commune: '',
    city: ''
  },
  phone: '',
  bankAccount: {
    bank: '',
    type: '',
    number: ''
  },
  updatedUser: false,
  error: null,
  hasCVL: false,
  hasSolicitudCredito: false,
  fetchingUserVigente: false,
  userVigente: []
}
export default createReducer(initialState, {
  [FETCH_USER_REQUEST]: (state) =>
    Object.assign({}, state, {
      fetchingUser: true
    }),
  [FETCH_USER_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      id: payload.id,
      username: payload.username,
      rut: payload.rut,
      type: payload.type,
      email: payload.email,
      fetchingUser: false
    }),
  [UNAUTH_USER]: (state) =>
    Object.assign({}, state, {
      id: null,
      username: ''
    }),
  [FETCH_USER_PERSONAL_DATA_REQUEST]: (state) =>
    Object.assign({}, state, {
      fetchingPersonalData: true
    }),
  [FETCH_USER_PERSONAL_DATA_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      id: payload.id,
      rut: payload.rut,
      type: payload.type,
      email: payload.email,
      name: payload.firstName.split(' ')[0],
      lastName: payload.lastName1,
      serialNumber: payload.serialNumber,
      statusCCR: payload.statusCCR,
      address: payload.address
        ? {
          street: payload.address.street,
          number: String(payload.address.number),
          apartOrHouse: payload.address.apartOrHouse,
          commune: payload.address.commune.id,
          region: payload.address.commune.regionId,
          city: payload.address.city
        }
        : {
          street: '',
          number: '',
          apartOrHouse: '',
          commune: '',
          region: '',
          city: ''
        },
      phone: payload.phone,
      bankAccount: payload.bankAccount
        ? {
          bank: payload.bankAccount.bankId,
          type: payload.bankAccount.type,
          number: payload.bankAccount.number
        }
        : {
          bank: '',
          type: '',
          number: ''
        },
      fetchingPersonalData: false,
      error: null
    }),
  [FETCH_USER_PERSONAL_DATA_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      fetchingPersonalData: false,
      updatedUser: false,
      error: payload
    }),
  [FETCH_UPDATE_USER_SUCCESS]: (state) =>
    Object.assign({}, state, {
      fetchingPersonalData: false,
      updatedUser: true,
      error: false
    }),
  [FETCH_UPDATE_USER_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      fetchingPersonalData: false,
      updatedUser: false,
      error: payload
    }),
  [USER_HAS_CVL]: (state) =>
    Object.assign({}, state, {
      hasCVL: true
    }),
  [USER_HAS_SOLICITUD_CREDITO]: (state, payload) =>
    Object.assign({}, state, {
      hasSolicitudCredito: payload
    }),
  [FETCH_USER_VIGENTE_REQUEST]: (state) =>
    Object.assign({}, state, {
      fetchingUserVigente: true
    }),
  [FETCH_USER_VIGENTE_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      userVigente: payload.tiposAfiliacion,
      fetchingUserVigente: false
    }),
  // [FETCH_USER_VIGENTE_SUCCESS]: (state, payload) =>
  //   Object.assign({}, state, {
  //     userVigente: payload.tiposAfiliacion,
  //     fetchingUserVigente: false
  //   }),
  [FETCH_USER_VIGENTE_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      userVigente: payload,
      fetchingUserVigente: false
    })
})
